<template>
  <div class="table">
    <el-table
      v-if="tableType=='score'"
      row-key="id"  
      :data="tableData"
      stripe
      style="width: 100%"
      max-height="360"
      min-height="120"
      :header-cell-style="{background:'#EFEFEF'}"
    >
      <el-table-column
        v-for="(item,index) in tableLabel"
        :width="item.width ? item.width : ''"
        :key="index"
        :align="item.align"
        :label="item.label"
        :prop="item.param"
        :sortable="item.sortable ? 'custom' : false"
      >
        <template slot-scope="scope">
          <span v-if="item.render">
            {{item.render(scope.row)}}
          </span>
          <span>{{scope.row[item.param]}}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-if="tableType=='rank'"
      max-height="360"
      min-height="120"
      row-key="id"
      :data="tableData"
      stripe
      style="width: 100%"
      :header-cell-style="{background:'#EFEFEF'}"
    >
      <el-table-column
        prop="disciplineName"
        label="科目"
      >
      </el-table-column>
      <el-table-column
        prop=""
        label="A"
      >
        <template slot-scope="scope">
          <span>{{scope.row.scoreMap.A||"0"}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        label="B"
      >
        <template slot-scope="scope">
          <span>{{scope.row.scoreMap.B||"0"}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        label="C"
      >
        <template slot-scope="scope">
          <span>{{scope.row.scoreMap.C||"0"}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        label="D"
      >
        <template slot-scope="scope">
          <span>{{scope.row.scoreMap.D||"0"}}</span>
        </template>
      </el-table-column>

    </el-table>
  </div>

</template>

<script>
export default {
  name: "autoTable",
  props: {
    tableData: {
      type: Array,
    },
    tableLabel: {
      type: Array,
    },
    tableType: {
      type: String,
    },
  },
  data() {
    return {
      //tableData: [
      //   {
      //     integralName: "长啥",
      //     company: "xued",
      //     integralNum: "19d",
      //   },
      //   {
      //     integralName: "长啥",
      //     company: "xued",
      //     integralNum: "19d",
      //   },
      // ],
      // tableLabel: [
      //   { label: "类型", param: "integralName" },
      //   { label: "积分", param: "integralNum" },
      //   // { label: "用户名", param: "usr", align: "center" },
      //   // { label: "公司名称", param: "company", align: "center" },
      //   // { label: "办公邮箱", param: "email", align: "center", width: "200" },
      // ],
    };
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.table {
  /deep/.el-table td {
    .el-table th {
      padding: 7px 20px;
    }
  }
}
</style>
